import {ViewChild, Component, OnInit} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import {RicambiService} from '../service/ricambi.service';
import {UserService} from '../service/user.service';
import {CompleterService, CompleterData} from 'ng2-completer';
import {ActivatedRoute, Params} from '@angular/router';
import {AppSettings} from '../models/AppSettings';
import {Matricola} from '../models/matricola';
import {Garanzia} from '../models/garanzia';
import {RigaGaranzia} from '../models/rigagaranzia';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';
import {MAT_DATE_FORMATS, DateAdapter, NativeDateAdapter} from '@angular/material';


@Component({
    selector: 'app-tws-garanzia',
    templateUrl: './tws-garanzia.component.html',
    styleUrls: ['./tws-garanzia.component.css']
})
export class TwsGaranziaComponent implements OnInit {
    @ViewChild('garanziaForm') currentForm: NgForm;
    @ViewChild("fileInput") fileInput;
    private dataService: CompleterData;
    public searchStr: string;
    public testo: string;
    public foto: string;
    public descrizione: string;
    public selezionato: Matricola;
    public garanzia: Garanzia;
    public fileSelezionato: any;
    public inviata: boolean = false;
    public counter: number = 1;
    public formErrors: any = {};
    public oggi: Date = new Date();

    public constructor(
        private ricambiService: RicambiService,
        private route: ActivatedRoute,
        private location: Location,
        public snackBar: MatSnackBar,
        private userService: UserService,
        public dateAdapter: DateAdapter<Date>,
        // public dateAdapter: DateAdapter<NativeDateAdapter>,
        //  public dateAdapter:DateAdapter,
        private completerService: CompleterService
    ) {
        this.dateAdapter.setLocale('it');
        this.dataService = completerService.remote(AppSettings.API_ENDPOINT + "ricambi?testo=", 'testo', 'codice').descriptionField("testo");
    }

    ngOnInit() {
        this.garanzia = new Garanzia();
        if (this.userService.getProfilo()) {
            this.garanzia.email = this.userService.getProfilo()["email"];
        }
        let riga: RigaGaranzia = new RigaGaranzia();
        riga.id = 1;
        this.garanzia.righe = new Array();
        this.garanzia.righe.push(riga);

        if (this.route && this.route.params && this.route.snapshot.params['id']) {
            this.route.params.switchMap((params: Params) => this.ricambiService.getMatricola(+params['id'])).subscribe(accessorio => this.matricolaSelezionata(accessorio));
        }
        this.inviata = false;
    }

    public matricolaSelezionata(matricola: Matricola) {
        this.selezionato = matricola;
        if (this.selezionato && this.selezionato.id > 0) {
            this.garanzia.codiceMacchina = matricola.macchina.codice;
            this.garanzia.modello = matricola.macchina.descrizione;
            this.foto = matricola.macchina.img;
            this.garanzia.serialNo = matricola.codice;

        }
    }

    public onSelected(selected: any) {
        if (selected) {
            this.selezionato = selected.originalObject;
        } else {
            this.selezionato = undefined;
        }
    }

    public onChange(event) {
        let fi = this.fileInput.nativeElement;
        if (fi.files && fi.files[0]) {
            this.fileSelezionato = fi.files[0];
        }
    }
    public formattaData(data: Date): any {
        let addZeroToLoneFigure = (n) => n.toString().length === 1 ? '0' + n : n.toString();

        let d = data;
        let format = '';
        format += "" + d.getFullYear();
        format += "-" + addZeroToLoneFigure(d.getMonth() + 1);
        format += "-" + addZeroToLoneFigure(d.getDate());
        return format;
    }

    public inviaRichiesta(): void {
        let valido: boolean = true;
        
        let righevalide:number=0;
        for (let x in this.garanzia.righe) {
            let i: RigaGaranzia = this.garanzia.righe[x];
            if (i.id > 0) {
                if (i.codice && !i.testo) {
                    valido = false;
                    this.formErrors["general"] = AppSettings.traduci("Compilare il campo note delle righe");
                }else{
                    if(i.codice){
                        righevalide++;
                    }
                }
            }
        }
        if (valido && righevalide < 1) {
            valido = false;
            this.formErrors["general"] = AppSettings.traduci("Inserire i componenti sostituiti");
        }
        if (!valido) {
            return;
        }
        /*if (!this.testo) {
            this.callback(AppSettings.traduci("Testo obbligatorio"));
            return;
        }*/
        //matricola/descrizione/testo/file
        let id = 0;
        if (this.selezionato) {
            id = this.selezionato.id;
        }
        /*
         * Le date le voglio dirette
         */
        this.garanzia.dataRottura = this.formattaData(this.garanzia.dataRottura);
        this.garanzia.dataVendita = this.formattaData(this.garanzia.dataVendita);
        this.ricambiService.inviaDatiGaranzia(id, this.garanzia).then(ordine => {
            this.ricambiService.inviaFileGaranzia(ordine["id"], this.fileSelezionato).then(garanzia => {
                this.callback(AppSettings.traduci("Richiesta di garanzia inviata"));
                this.selezionato = undefined;
                this.garanzia = garanzia;
                this.descrizione = "";
                this.testo = "";
                this.inviata = true;
                this.fileSelezionato = undefined;
            })
        });
    }

    callback(msg: string) {
        this.snackBar.open(msg, "", {duration: 2000});
    }

    aggiungiRiga() {
        this.counter++;
        let riga: RigaGaranzia = new RigaGaranzia();
        riga.id = this.counter;
        this.garanzia.righe.push(riga);
    }

    rimuoviRiga(riga: RigaGaranzia) {
        riga.id = -1;
    }

    get utente(): any {
        return this.userService.getProfilo();
    }
    selezionatoEvento(oggetto: any, riga: RigaGaranzia) {
        riga.descrizione = oggetto.originalObject.descrizione;

    }
}



// WEBPACK FOOTER //
// ./src/app/tws-garanzia/tws-garanzia.component.ts